export enum CmsRoutesFlightTypeEnum {
  nonstop = '0',
}

export enum CmsRoutesBooleanEnum {
  true = '1',
  false = '0',
}
